import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "./utils"

export interface Security {
  id: string
  name: string
}

export interface FetchSecuritiesOptions {
  managed?: boolean
  quadrant?: boolean
}

export const fetchSecurities = async (
  options: FetchSecuritiesOptions = {},
): Promise<Security[]> => {
  const queryParams = new URLSearchParams()

  if (options.managed !== undefined) {
    queryParams.append("managed", options.managed.toString())
  }

  if (options.quadrant !== undefined) {
    queryParams.append("quadrant", options.quadrant.toString())
  }

  const url = `/api/securities${
    queryParams.toString() ? `?${queryParams.toString()}` : ""
  }`

  return apiFetch<Security[]>(url)
}

export const useSecurities = (options: FetchSecuritiesOptions = {}) => {
  return useQuery({
    queryKey: ["securities", options],
    queryFn: () => fetchSecurities(options),
  })
}
